
import HeadingLv4 from '@/components/elements/HeadingLv4.vue'
import TextBlock from '@/components/block/TextBlock.vue'
import TextLink from '@/components/elements/TextLink.vue'

export default {
  name: 'DoctorRegister',

  components: {
    HeadingLv4,
    TextBlock,
    TextLink
  }
}
